var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81218 16.0672L0.744835 26.819C0.267772 27.3881 0 28.1579 0 28.9603C0 29.7627 0.267772 30.5325 0.744835 31.1016C0.98295 31.3863 1.26624 31.6122 1.57837 31.7664C1.8905 31.9206 2.22529 32 2.56343 32C2.90156 32 3.23635 31.9206 3.54848 31.7664C3.86061 31.6122 4.1439 31.3863 4.38202 31.1016L15.2423 18.2236C15.4824 17.9413 15.673 17.6053 15.803 17.2352C15.933 16.8651 16 16.4681 16 16.0672C16 15.6662 15.933 15.2692 15.803 14.8991C15.673 14.529 15.4824 14.1931 15.2423 13.9107L4.38202 0.880859C4.14268 0.599362 3.85884 0.376656 3.54676 0.225508C3.23469 0.0743598 2.90052 -0.00225953 2.56343 5.14984e-05C2.22633 -0.00225953 1.89216 0.0743598 1.58009 0.225508C1.26802 0.376656 0.984172 0.599362 0.744835 0.880859C0.267772 1.44993 0 2.21973 0 3.02213C0 3.82453 0.267772 4.59432 0.744835 5.16339L9.81218 16.0672Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowTransparent);
export default __webpack_public_path__ + "static/media/right-arrow-transparent.fce5940110c6eb4b059a76861f94938e.svg";
export { ForwardRef as ReactComponent };